import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import moment from 'moment';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss']
})
export class CustomerComponent implements OnInit {

  @Input()
  addressEnabled: boolean;

  @Input()
  formSubmitAttempted: boolean;

  @Input()
  isMilesAndMoreCustomer: boolean;

  @Input()
  milesAndMoreServiceNumber: string;

  emailFormControl = new FormControl('', [Validators.email, Validators.required]);
  phoneFormControl = new FormControl('', this.getPhoneValidators());
  salutationFormControl = new FormControl('', [Validators.required]);
  firstNameFormControl = new FormControl('', [Validators.required]);
  lastNameFormControl = new FormControl('', [Validators.required]);
  birthdayFormControl = new FormControl('', [this.birthdayAtLeast18YearsValidator]);
  zipCodeFormControl = new FormControl('', [Validators.required, Validators.pattern('[0-9]{5}')]);
  cityFormControl = new FormControl('', [Validators.required]);
  reachabilityFormControl = new FormControl('', [Validators.required]);
  milesAndMoreServiceNumberFormControl: FormControl;

  @Output()
  onValidChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  ngOnInit(): void {
    this.emailFormControl.valueChanges.subscribe(this.updateValidChange.bind(this));
    this.phoneFormControl.valueChanges.subscribe(this.updateValidChange.bind(this));
    this.salutationFormControl.valueChanges.subscribe(this.updateValidChange.bind(this));
    this.firstNameFormControl.valueChanges.subscribe(this.updateValidChange.bind(this));
    this.lastNameFormControl.valueChanges.subscribe(this.updateValidChange.bind(this));
    this.birthdayFormControl.valueChanges.subscribe(this.updateValidChange.bind(this));
    this.zipCodeFormControl.valueChanges.subscribe(this.updateValidChange.bind(this));
    this.cityFormControl.valueChanges.subscribe(this.updateValidChange.bind(this));
    this.reachabilityFormControl.valueChanges.subscribe(() => {
      this.phoneFormControl.setValidators(this.getPhoneValidators());
      this.phoneFormControl.updateValueAndValidity();
      this.updateValidChange();
    });
    this.milesAndMoreServiceNumberFormControl = new FormControl(this.milesAndMoreServiceNumber ?? '', [Validators.required, Validators.pattern('[0-9]{15}')]);
    this.milesAndMoreServiceNumberFormControl.valueChanges.subscribe(this.updateValidChange.bind(this));
  }

  birthdayAtLeast18YearsValidator(control: FormControl): { [s: string]: string } {
    if (control.value) {
      const moment18yearsAgo = moment().subtract(18, 'year');
      const value = moment(control.value);
      if (value.isAfter(moment18yearsAgo)) {
        const maxDatePretty = moment18yearsAgo.day() + '.' + moment18yearsAgo.month() + '.' + moment18yearsAgo.year();
        return {maxDate: maxDatePretty};
      }
    }
    return null;
  }

  getPhoneValidators() {
    return this.reachabilityFormControl?.value === 'Telefon' ?
      [Validators.pattern(this.getPhonePattern()), Validators.required]
      : [Validators.pattern(this.getPhonePattern())];
  }

  getPhonePattern(): string {
    return '[0-9 ()+\-]*';
  }

  updateValidChange() {
    this.onValidChange.emit(
      this.emailFormControl.valid &&
      this.salutationFormControl.valid &&
      this.firstNameFormControl.valid &&
      this.lastNameFormControl.valid &&
      this.birthdayFormControl.valid &&
      this.zipCodeFormControl.valid &&
      this.reachabilityFormControl.valid &&
      this.phoneFormControl.valid &&
      this.cityFormControl.valid &&
      (!this.isMilesAndMoreCustomer || this.milesAndMoreServiceNumberFormControl.valid)
    );
  }

}
